














import { Component, Vue } from "vue-property-decorator";
@Component
export default class Exception403 extends Vue {
    toHome(): void {
        this.$router.push({ path: "/" });
    }
}
